const logsStore: Record<string, any> = {};

export const addLog = (value: Record<string, any>) => {
  let dateTimeKey = new Date().toISOString();

  while (logsStore[dateTimeKey]) {
    dateTimeKey += 'Z';
  }

  logsStore[dateTimeKey] = value;
};

export const addLogByKey = (key: string, value: Record<string, any>) => {
  const dateTime = new Date().toISOString();
  let uniqueKey = key;
  let counter = 1;

  while (logsStore[uniqueKey]) {
    uniqueKey = `${key}_${counter}`;
    counter++;
  }

  logsStore[uniqueKey] = { ...value, dateTime };
};

export const getLog = () => logsStore;
